import { useState, useEffect } from 'react';
import { useUI } from '../context/UIContext';
import { useAuth } from '../context/AuthContext';
import { useProfile } from '../context/ProfileContext';
import { supabase } from '../lib/supabase';
import CreatePostModal from './modals/CreatePostModal';

const PostModalWrapper = () => {
  const { showPostModal, setShowPostModal, triggerHomeRefresh } = useUI();
  const { user } = useAuth();
  const { activeProfileId } = useProfile();
  const [userId, setUserId] = useState(null);
  const [userCards, setUserCards] = useState([]);

  // Fetch user profile and cards when modal opens
  useEffect(() => {
    const fetchData = async () => {
      if (!showPostModal || !user) return;

      try {
        // Get logged-in user's profile ID
        const { data: profileData } = await supabase
          .from('users')
          .select('id')
          .eq('auth_id', user.id)
          .single();

        if (profileData) {
          // Use activeProfileId if viewing as child, otherwise use logged-in user's profile
          const effectiveUserId = (activeProfileId && activeProfileId !== profileData.id)
            ? activeProfileId
            : profileData.id;

          setUserId(effectiveUserId);

          // Fetch the effective user's cards
          const { data: cardsData } = await supabase
            .from('cards')
            .select('*')
            .eq('user_id', effectiveUserId)
            .is('deleted_at', null)
            .order('created_at', { ascending: false });

          if (cardsData) {
            setUserCards(cardsData);
          }
        }
      } catch (err) {
        console.error('Error fetching user data:', err);
      }
    };

    fetchData();
  }, [showPostModal, user, activeProfileId]);

  const handleSuccess = () => {
    // Trigger home feed refresh so new post appears at top
    triggerHomeRefresh();
  };

  return (
    <CreatePostModal
      isOpen={showPostModal}
      onClose={() => setShowPostModal(false)}
      userId={userId}
      userCards={userCards}
      onSuccess={handleSuccess}
    />
  );
};

export default PostModalWrapper;
